<ng-container [formGroup]="form">
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">{{ header }}</h5>
  </div>

  <div class="modal-body container" ngbAutofocus>
    <app-dc-loading *ngIf="loading"></app-dc-loading>
    <div class="form-row col-lg-7 topRow">
      <div
        class="form-group col-lg performanceType"
        *ngIf="form.get('performanceType') as performanceType"
        [hidden]="performanceType.disabled"
      >
        <app-dc-select
          formControlName="performanceType"
          [labelId]="'performanceType'"
          [label]="labels.summary.underlyingAssetsGroup.performanceType"
          [items]="
            performanceTypeItems
              | filterPerformanceType
                : form.get('underlyingAssets').value
                : productTypeValue
          "
          closeOnSelect="true"
          [readonly]="performanceType.readOnly"
        ></app-dc-select>
      </div>
      <div
        class="form-group col-lg settlementType"
        *ngIf="form.get('settlementType') as settlementType"
        [hidden]="settlementType.disabled"
      >
        <app-dc-select
          formControlName="settlementType"
          [labelId]="'settlementType'"
          [warning]="
            isSettlementWarning()
              ? 'You selected Physical settlement but your underlying asset selection includes one or more Indices'
              : ''
          "
          [label]="labels.summary.underlyingAssetsGroup.settlementType"
          [items]="settlementTypeItems"
          closeOnSelect="true"
          [clearSelection]="true"
          [readonly]="settlementType.readOnly"
        ></app-dc-select>
      </div>
      <div
        class="form-group col-lg rollAs"
        *ngIf="modalMode() !== ModalMode.bond && form.get('rollAs') as rollAs"
        [hidden]="rollAs.disabled"
      >
        <app-dc-select
          formControlName="rollAs"
          [labelId]="'rollAs'"
          [label]="labels.summary.underlyingAssetsGroup.rollAs"
          [items]="rollAsItems"
          closeOnSelect="true"
          [clearSelection]="true"
          [readonly]="rollAs.readOnly"
        ></app-dc-select>
      </div>
    </div>

    <!-- Bond Asset -->
    <ng-container *ngIf="modalMode() === ModalMode.bond">
      <div class="form-row labelContainer">
        <div class="form-row col-lg-11">
          <div class="col-lg-2">
            <label class="colHeader">Underlying Asset</label>
          </div>
          <div class="col-lg-2">
            <label class="colHeader">Source Page</label>
          </div>
          <div class="col-lg-2">
            <label class="colHeader">Initial Strike (Clean)</label>
          </div>
          <div class="col-lg-2">
            <label class="colHeader">Forward Accrual Coupon</label>
          </div>
          <div class="col-lg-2">
            <label class="colHeader">Initial Strike (Dirty)</label>
          </div>
          <div class="col-lg-2">
            <label class="colHeader">
              Deliverable Number of Underlying Assets
              <app-dc-popover
                [body]="'Underlying Assets must have a denomination value.\n\n'+
                'Legal Form must have a valid denomination value.'"
                class="helpText">
              </app-dc-popover>
            </label>
          </div>
        </div>
      </div>
      <ng-container formGroupName="underlyingAssets">
        <div
          class="form-group assets"
          *ngFor="
            let a of assets.controls;
            let i = index;
            let last = last;
            let first = first
          "
        >
          <div class="form-row align align-items-end" [formGroupName]="i">
            <div class="form-row col-lg-11">
              <div class="col-2 typeaheadOnly asset">
                <app-dc-select
                  formControlName="assetId"
                  [id]="'assetId'"
                  [items]="
                    underlyingAssetsItems
                      | filterAssets: form.get('underlyingAssets').value
                  "
                  closeOnSelect="true"
                  searchable="true"
                  (selected)="updateReadonlyFields($event, i)"
                ></app-dc-select>
              </div>
              <div class="col-2">
                <app-dc-input
                  formControlName="sourcePage"
                  [id]="'sourcePage'"
                  type="text"
                ></app-dc-input>
              </div>
              <div class="col-2">
                <app-dc-input-number-percent-indicative-final
                  [id]="'initialStrikeClean'"
                  [minMaxIndicativeToggle]="false"
                  [lockDefault]="true"
                  defaultUnit="pct"
                  formControlName="initialStrikeClean"
                ></app-dc-input-number-percent-indicative-final>
              </div>
              <div class="col-2">
                <app-dc-input-number-percent-indicative-final
                  [id]="'forwardAccruedCoupon'"
                  [minMaxIndicativeToggle]="false"
                  [lockDefault]="true"
                  defaultUnit="pct"
                  formControlName="forwardAccruedCoupon"
                ></app-dc-input-number-percent-indicative-final>
              </div>
              <div class="col-2">
                <app-dc-input-number-percent-indicative-final
                  [id]="'initialStrikeDirty'"
                  [minMaxIndicativeToggle]="false"
                  [lockDefault]="true"
                  formControlName="initialStrikeDirty"
                  defaultUnit="pct"
                  readonly="true"
                ></app-dc-input-number-percent-indicative-final>
              </div>
              <div class="col-2">
                <app-dc-input-numeric
                  [id]="'numDeliverableUnderlyingAssets'"
                  formControlName="numDeliverableUnderlyingAssets"
                  readonly="true"
                ></app-dc-input-numeric>
              </div>
            </div>
            <div class="form-row col-lg-1">
              <button
                (click)="deleteAsset(i)"
                class="minus btn btn-link"
                type="button"
                title="Delete row"
              ></button>
              <button
                *ngIf="last && allowMultipleAssets"
                (click)="addAsset(null, i + 1)"
                class="btn btn-link plus"
                type="button"
                title="Add row"
              ></button>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- Dynamic array for NOT FX Pair mode -->
    <ng-container *ngIf="modalMode() === ModalMode.none">
      <div class="form-row labelContainer">
        <div class="form-row col-lg-5">
          <div class="col-lg-7">
            <label class="colHeader">Asset</label>
          </div>
          <div class="col-lg-3">
            <label class="colHeader">Market</label>
          </div>
          <div class="col-lg-2">
            <label class="colHeader">Sett. CCY</label>
          </div>
        </div>
        <div class="form-row col-lg-7">
          <div class="col-lg-3 calendarLabel">
            <label class="colHeader">Calendar(s)</label>
          </div>
          <div
            *ngIf="showInitialFixing"
            [ngClass]="
              form.get('performanceType').value === 'BASKET'
                ? 'col-lg-1'
                : 'col-lg-2'
            "
          >
            <label class="colHeader">Initial Fixing</label>
          </div>
          <div class="col-lg-3">
            <label class="colHeader">Initial Fixing Date</label>
          </div>
          <div class="col-lg-3">
            <label class="colHeader">Fixing Type</label>
          </div>
          <div
            class="col-lg-1"
            *ngIf="form.get('performanceType').value === 'BASKET'"
          >
            <label class="colHeader">Weight</label>
          </div>
        </div>
      </div>
      <ng-container formGroupName="underlyingAssets">
        <div
          class="form-group assets"
          *ngFor="
            let a of assets.controls;
            let i = index;
            let last = last;
            let first = first
          "
        >
          <div class="form-row align align-items-end" [formGroupName]="i">
            <div class="form-row col-lg-5">
              <div class="col-lg-7 typeaheadOnly asset">
                <app-dc-select
                  formControlName="assetId"
                  [id]="'assetId'"
                  [items]="
                    underlyingAssetsItems
                      | filterAssets: form.get('underlyingAssets').value
                  "
                  closeOnSelect="true"
                  searchable="true"
                  (selected)="updateReadonlyFields($event, i)"
                ></app-dc-select>
              </div>
              <div class="col-lg-3 market">
                <app-dc-input
                  formControlName="exchange"
                  [id]="'exchange'"
                  [readonly]="true"
                ></app-dc-input>
              </div>
              <div class="col-lg-2 currency">
                <app-dc-input
                  formControlName="currency"
                  [id]="'currency'"
                  [readonly]="true"
                ></app-dc-input>
              </div>
            </div>
            <div class="form-row col-lg-7">
              <div class="col-lg-3 calendars p-2">
                <ng-container
                  *ngFor="
                    let calendar of form.get('underlyingAssets').value[i]
                      ?.calendars
                  "
                >
                  <span [title]="calendar" class="badge bg-primary mr-1">
                    {{ calendar }}
                  </span>
                </ng-container>
              </div>
              <div
                *ngIf="showInitialFixing"
                [ngClass]="
                  form.get('performanceType').value === 'BASKET'
                    ? 'col-lg-1'
                    : 'col-lg-2'
                "
              >
                <app-dc-input-number-percent-indicative-final
                  id="'initialFixing'"
                  defaultUnit="'abs'"
                  formControlName="initialFixing"
                  [minMaxIndicativeToggle]="false"
                  [lockDefault]="true"
                ></app-dc-input-number-percent-indicative-final>
              </div>
              <div class="col-lg-3 weight">
                <app-dc-date-input
                  id="initial_FixingDate"
                  type="text"
                  placeholder="-"
                  formControlName="initial_FixingDate"
                  container="body"
                ></app-dc-date-input>
              </div>
              <div class="col-lg-3">
                <app-dc-select
                  formControlName="fixingType"
                  [labelId]="'fixingType'"
                  [items]="fixingTypeItems"
                  closeOnSelect="true"
                  [clearSelection]="true"
                ></app-dc-select>
              </div>
              <div
                class="col-lg-1 weight"
                *ngIf="form.get('performanceType').value === 'BASKET'"
              >
                <app-dc-input
                  [id]="'weight'"
                  type="number"
                  formControlName="weight"
                ></app-dc-input>
              </div>
              <button
                (click)="deleteAsset(i)"
                class="minus btn btn-link"
                type="button"
                title="Delete row"
              ></button>
              <button
                *ngIf="last && allowMultipleAssets"
                (click)="addAsset(null, i + 1)"
                class="btn btn-link plus"
                type="button"
                title="Add row"
              ></button>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- Dynamic array for FX Pair mode -->
    <ng-container *ngIf="modalMode() === ModalMode.fxPair">
      <div class="form-row labelContainer">
        <div class="form-row col-lg-12">
          <div class="col-lg-3">
            <label class="colHeader">FX Pair</label>
          </div>
          <div class="col-lg-3">
            <label class="colHeader">Source Page</label>
          </div>
          <div class="col-lg-2">
            <label class="colHeader">Rate Obs. Time</label>
          </div>
          <div class="col-lg-1" *ngIf="showInitialFixing">
            <label class="colHeader">Initial Fixing</label>
          </div>
          <div class="col-lg-1">
            <label class="colHeader">Fixing Type</label>
          </div>
          <ng-container *ngIf="productTypeValue === 'CHOOSER'">
            <div class="col-lg-1">
              <label class="colHeader">Coupon Strike</label>
            </div>
            <div class="col-lg-2">
              <label class="colHeader">Redemption Amount</label>
            </div>
          </ng-container>
        </div>
      </div>
      <ng-container formGroupName="underlyingAssets">
        <div
          class="form-group assets"
          *ngFor="
            let a of assets.controls;
            let i = index;
            let last = last;
            let first = first
          "
        >
          <div class="form-row align align-items-end" [formGroupName]="i">
            <div class="form-row col-lg-12">
              <div class="col-lg-3 typeaheadOnly asset">
                <app-dc-select
                  formControlName="assetId"
                  [id]="'assetId'"
                  [items]="
                    underlyingAssetsItems
                      | filterAssets: form.get('underlyingAssets').value
                      | filterFxAssets: productTypeValue:productCurrency
                  "
                  closeOnSelect="true"
                  searchable="true"
                  (selected)="updateReadonlyFields($event, i)"
                ></app-dc-select>
              </div>
              <div class="col-lg-3">
                <app-dc-input
                  formControlName="sourcePage"
                  [id]="'sourcePage'"
                  type="text"
                ></app-dc-input>
              </div>
              <div class="col-lg-2">
                <app-dc-select
                  formControlName="fixingTime"
                  [labelId]="'fixingTime'"
                  [items]="fixingTimeItems"
                  closeOnSelect="true"
                  [clearSelection]="true"
                ></app-dc-select>
              </div>
              <div class="col-lg-1" *ngIf="showInitialFixing">
                <app-dc-input-number-percent-indicative-final
                  id="'initialFixing'"
                  defaultUnit="'abs'"
                  formControlName="initialFixing"
                  [minMaxIndicativeToggle]="false"
                  [lockDefault]="true"
                ></app-dc-input-number-percent-indicative-final>
              </div>
              <div class="col-lg-1">
                <app-dc-select
                  formControlName="fixingType"
                  [labelId]="'fixingType'"
                  [items]="fixingTypeFxPairItems"
                  closeOnSelect="true"
                  [clearSelection]="true"
                ></app-dc-select>
              </div>
              <ng-container *ngIf="productTypeValue === 'CHOOSER'">
                <div class="col-lg-1">
                  <app-dc-input-number-percent-indicative-final
                    id="'couponStrike'"
                    defaultUnit="abs"
                    formControlName="couponStrike"
                    [minMaxIndicativeToggle]="false"
                    [lockDefault]="true"
                  ></app-dc-input-number-percent-indicative-final>
                </div>
                <div class="col-lg-2">
                  <app-dc-input-number-percent-indicative-final
                    id="'redemptionStrike'"
                    defaultUnit="abs"
                    formControlName="redemptionStrike"
                    [minMaxIndicativeToggle]="false"
                    [lockDefault]="true"
                  ></app-dc-input-number-percent-indicative-final>
                </div>
              </ng-container>
              <button
                *ngIf="allowAddingDeletingAssets"
                (click)="deleteAsset(i)"
                class="minus btn btn-link"
                type="button"
                title="Delete row"
              ></button>
              <button
                *ngIf="last && allowMultipleAssets && allowAddingDeletingAssets"
                (click)="addAsset(null, i + 1)"
                class="btn btn-link plus"
                type="button"
                title="Add row"
              ></button>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div class="modal-footer justify-content-right">
    <button
      type="button"
      class="btn btn-secondary btn-sm"
      (click)="clearModal()"
    >
      Cancel
    </button>
    <button type="button" class="btn btn-primary btn-sm" (click)="save()">
      Save
    </button>
  </div>
</ng-container>
